module.exports = __webpack_public_path__ + "img/cardRed.34954fcb.png";